/**
 * OFE fat skill — shared React data hooks.
 * All hooks respect the X-User header set in AuthContext.
 */
import { useState, useEffect, useCallback } from 'react';

const API = process.env.REACT_APP_API_URL || '';

function headers(user) {
  return {
    'Content-Type': 'application/json',
    ...(user?.username ? { 'X-User': user.username } : {}),
  };
}

export function useOFEFetch(path, user, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await fetch(`${API}${path}`, { headers: headers(user), credentials: 'include' });
      if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
      setData(await r.json());
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [path, user, ...deps]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { load(); }, [load]);
  return { data, loading, error, reload: load };
}

export async function ofePost(path, body, user) {
  const r = await fetch(`${API}${path}`, {
    method: 'POST',
    headers: headers(user),
    credentials: 'include',
    body: JSON.stringify(body),
  });
  if (!r.ok) {
    const err = await r.json().catch(() => ({ detail: r.statusText }));
    throw new Error(err.detail || r.statusText);
  }
  return r.json();
}

export async function ofePatch(path, body, user) {
  const r = await fetch(`${API}${path}`, {
    method: 'PATCH',
    headers: headers(user),
    credentials: 'include',
    body: JSON.stringify(body),
  });
  if (!r.ok) {
    const err = await r.json().catch(() => ({ detail: r.statusText }));
    throw new Error(err.detail || r.statusText);
  }
  return r.json();
}
